var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendarDay14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2zM9 5h6v2h2V5h3v14H4V5h3v2h2zm-.023 11h1.485V9.602h-.136l-2.808.97v1.126l1.459-.427zm7.976-2.5h-.65V9.602H14.82v.013l-2.562 4.122.088.905h2.474V16h1.481v-1.358h.65zm-2.132 0H13.67l1.059-1.82.092-.15z",
  clipRule: "evenodd"
})));
export default SvgCalendarDay14;